import { createContext } from 'react';

const TrackContext =  createContext();

export default TrackContext;